var _rect, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSponsor3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 303,
    height: 178,
    viewBox: "0 0 303 178",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.00878906,
    y: 0.583984,
    width: 302,
    height: 177,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_869_2239",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 68,
    width: 236,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M268.955 68H33.2056V109H268.955V68Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_869_2239)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104.597 93.4373C104.597 96.5498 101.694 98.8037 97.6079 98.8037H88.0391V79.4844H97.2854C101.264 79.4844 104.059 81.631 104.059 84.6362C104.059 86.6755 102.984 87.9634 101.371 88.7147C103.091 89.3587 104.597 91.076 104.597 93.4373ZM92.232 83.0263V87.2121H97.1778C98.6831 87.2121 99.6507 86.3535 99.6507 85.1729C99.6507 83.9922 98.5755 83.0263 97.1778 83.0263H92.232ZM97.6079 95.2619C99.2207 95.2619 100.404 94.2959 100.404 92.9006C100.404 91.5053 99.3283 90.5394 97.6079 90.5394H92.232V95.2619H97.6079Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.401 98.6964L113.736 91.076H112.66V98.6964H108.359V79.4844H112.66V86.8901H113.736L120.186 79.4844H125.24L117.176 88.7147L125.992 98.6964H120.401Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.993 89.144C125.993 83.3482 130.293 79.1624 136.314 79.1624C142.335 79.1624 146.636 83.3482 146.636 89.144C146.636 94.9399 142.335 99.1257 136.314 99.1257C130.293 99.1257 125.993 94.9399 125.993 89.144ZM142.12 89.144C142.12 85.4948 139.754 83.0262 136.314 83.0262C132.873 83.0262 130.508 85.4948 130.508 89.144C130.508 92.7933 132.873 95.2619 136.314 95.2619C139.754 95.2619 142.12 92.7933 142.12 89.144Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.086 79.4844H167.386V98.6964H163.086V90.9687H154.484V98.6964H150.184V79.4844H154.484V87.1048H163.086V79.4844Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.633 98.6964V83.3483H169.966V79.4844H187.492V83.3483H180.826V98.6964H176.633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.985 87.9634V98.6964H202.866L202.006 95.6912C201.039 97.3011 198.996 99.1257 195.878 99.1257C192.007 99.1257 189.212 96.5498 189.212 93.0079C189.212 89.466 192.007 86.9975 197.706 86.9975H201.899C201.684 84.5288 200.394 82.8116 198.028 82.8116C196.093 82.8116 194.803 83.8849 194.158 85.0655L190.287 84.4215C191.255 81.0943 194.588 79.1624 198.244 79.1624C202.974 79.1624 205.985 82.3822 205.985 87.9634ZM201.791 90.3247H197.813C194.588 90.3247 193.512 91.398 193.512 92.7933C193.512 94.4032 194.803 95.4765 196.953 95.4765C199.749 95.4765 201.791 93.4372 201.791 90.3247Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.542 98.6964L215.876 91.076H214.801V98.6964H210.5V79.4844H214.801V86.8901H215.876L222.327 79.4844H227.38L219.317 88.7147L228.133 98.6964H222.542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.874 98.6964V83.3483H229.208V79.4844H246.734V83.3483H240.067V98.6964H235.874Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.236 90.3247H252.754C253.184 93.3299 255.335 95.2619 258.56 95.2619C260.818 95.2619 262.538 94.2959 263.506 92.9006L267.484 93.5446C266.086 97.1938 262.323 99.1257 258.238 99.1257C252.432 99.1257 248.238 94.9399 248.238 89.144C248.238 83.3482 252.432 79.1624 258.238 79.1624C264.043 79.1624 268.236 83.3482 268.236 88.9294C268.344 89.466 268.236 89.8954 268.236 90.3247ZM253.076 86.9975H263.721C262.968 84.6362 261.033 82.9189 258.345 82.9189C255.765 82.8116 253.722 84.5288 253.076 86.9975Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2056 87.68C33.2056 78.4028 33.2056 73.7641 36.0926 70.8821C38.9797 68 43.6264 68 52.9198 68H54.5626C63.856 68 68.5027 68 71.3898 70.8821C74.2769 73.7641 74.2769 78.4028 74.2769 87.68V89.32C74.2769 98.5972 74.2769 103.236 71.3898 106.118C68.5027 109 63.856 109 54.5626 109H52.9198C43.6264 109 38.9797 109 36.0926 106.118C33.2056 103.236 33.2056 98.5972 33.2056 89.32V87.68Z",
    fill: "#0077FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0587 97.5372C45.6979 97.5372 40.3587 91.1309 40.1362 80.4709H44.8252C44.9792 88.2951 48.436 91.6093 51.174 92.2926V80.4709H55.5893V87.2188C58.2932 86.9284 61.1336 83.8534 62.092 80.4709H66.5073C65.7714 84.6393 62.691 87.7143 60.5006 88.9784C62.691 90.0034 66.1994 92.6855 67.5342 97.5372H62.6739C61.6301 94.2914 59.0291 91.7801 55.5893 91.4384V97.5372H55.0587Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor3);
export default __webpack_public_path__ + "static/media/Sponsor3.5682be1c20107be12210087c4cb86889.svg";
export { ForwardRef as ReactComponent };